import React from 'react';
interface DetailFieldProps {
  label: string;
  children: React.ReactNode;
  full?: boolean;
}
export function DetailField({
  label,
  children,
  full = false
}: DetailFieldProps) {
  return <div className={`space-y-1 ${full ? 'col-span-full' : ''}`} data-id="element-1215" data-mp="2ogno8hgk8knk">
      <dt className="text-xs font-medium text-slate-500" data-id="element-1216" data-mp="2oet61awob6n6">{label}</dt>
      <dd className="text-sm font-medium text-slate-800" data-id="element-1217" data-mp="2jh1fak7rlqkk">{children || '-'}</dd>
    </div>;
}